export default {"src":"/_next/static/media/stm32-loading-project.9abab334.gif","height":773,"width":1016,"blurWidth":0,"blurHeight":0};